














































import { DateTime } from "luxon";
import { Component, Ref, Vue, Watch } from "vue-property-decorator";
import DateField from "@/components/misc/DateField.vue";
import { Action, Getter } from "vuex-class";

@Component({ components: { DateField } })
export default class TimeTrackNav extends Vue {
  @Getter("language/language") language?: string;

  @Getter("calendar/isLoading") loading?: boolean;
  @Getter("calendar/currentDay") currentDay?: DateTime;
  @Action("calendar/goToDay") goToDay?: (payload: DateTime) => void;
  @Getter("calendar/months") months?: string;

  dateFieldModel = DateTime.local().toISODate()?.substring(0, 7);

  @Watch("currentDay", { immediate: true })
  currentChanged(fresh: DateTime) {
    this.dateFieldModel =
      fresh.toISODate() ?? new Date().toJSON().substring(0, 7);
  }

  selected(evt: string) {
    if (this.goToDay) {
      try {
        this.goToDay(DateTime.fromISO(evt));
      } catch {
        this.$store.dispatch("showNotification", {
          color: "error",
          message: this.$t("Selected date is not a valid ISODate"),
          timeout: 5000,
        });
      }
    }
  }

  /* Vuetify has a bug where it retains focus, :retain-focus-on-click="false" doesn't fix it 
  https://github.com/vuetifyjs/vuetify/issues/3125#issuecomment-527843283 */
  @Ref("navRightBtn") navRightBtn?: Vue;
  navRight() {
    if (this.navRightBtn?.$el instanceof HTMLElement) {
      this.navRightBtn?.$el.blur();
    }
    if (this.goToDay && this.currentDay) {
      this.goToDay(this.currentDay.plus({ months: 1 }));
    }
  }
  @Ref("navLeftBtn") navLeftBtn?: Vue;
  navLeft() {
    if (this.navLeftBtn?.$el instanceof HTMLElement) {
      this.navLeftBtn?.$el.blur();
    }
    if (this.goToDay && this.currentDay) {
      this.goToDay(this.currentDay.minus({ months: 1 }));
    }
  }
  @Ref("navTodayBtn") navTodayBtn?: Vue;
  navToday() {
    if (this.navTodayBtn?.$el instanceof HTMLElement) {
      this.navTodayBtn?.$el.blur();
    }
    if (this.goToDay) {
      this.goToDay(DateTime.local().startOf("day"));
    }
  }
}
